import {
  topbarHeight,
  topbarHeightMedium,
} from "../../../components/topBar/constants";
import { screenSizeTokens } from "../designTokens/screenSize/tokens/screenSizeTokens";

export const responsiveValues = {
  "--topbar-height": `${topbarHeight}px`,
  [screenSizeTokens.$medium]: {
    "--topbar-height": `${topbarHeightMedium}px`,
  },
};
